import "./Tab.scss";

const TabLarge = ({ title }) => {
  return <span className="tab large hover-underline-animation">{title}</span>;
};

export default TabLarge;
